<script>
  // make dynamic date to be added to footer
  let date = new Date().getFullYear();
</script>

<footer class="absolute bottom-0 py-4 w-full">
  <div class="container mx-auto">
    <hr class="border-b-1 border-blueGray-200" />
    <div class="flex flex-wrap items-center justify-center">
      <div class="w-full md:w-8/12">
<!--        <ul class="flex flex-wrap list-none justify-center">-->
<!--          <li>-->
<!--            <a-->
<!--              href="https://www.creative-tim.com?ref=ns-footer-admin"-->
<!--              class="text-blueGray-600 hover:text-blueGray-800 text-sm font-semibold block py-1 px-3"-->
<!--            >-->
<!--              Creative Tim-->
<!--            </a>-->
<!--          </li>-->
<!--          <li>-->
<!--            <a-->
<!--              href="https://www.creative-tim.com/presentation?ref=ns-footer-admin"-->
<!--              class="text-blueGray-600 hover:text-blueGray-800 text-sm font-semibold block py-1 px-3"-->
<!--            >-->
<!--              About Us-->
<!--            </a>-->
<!--          </li>-->
<!--          <li>-->
<!--            <a-->
<!--              href="http://blog.creative-tim.com?ref=ns-footer-admin"-->
<!--              class="text-blueGray-600 hover:text-blueGray-800 text-sm font-semibold block py-1 px-3"-->
<!--            >-->
<!--              Blog-->
<!--            </a>-->
<!--          </li>-->
<!--          <li>-->
<!--            <a-->
<!--              href="https://github.com/creativetimofficial/notus-svelte/blob/main/LICENSE.md?ref=ns-footer-admin"-->
<!--              class="text-blueGray-600 hover:text-blueGray-800 text-sm font-semibold block py-1 px-3"-->
<!--            >-->
<!--              MIT License-->
<!--            </a>-->
<!--          </li>-->
<!--        </ul>-->
      </div>
    </div>
  </div>
</footer>
